import {
  CustomAttributeOption,
  CustomAttributeType,
  CustomAttributeValue,
} from 'src/graphql/entities/custom-attributes/custom-attributes.types';

export function getKindLikeValueSafely<K extends CustomAttributeType>(
  value: CustomAttributeValue,
  kind: K,
): Extract<CustomAttributeValue, { kind: K }>['value'] | null;

export function getKindLikeValueSafely(
  value: CustomAttributeValue,
  kind: CustomAttributeType,
) {
  return value.kind === kind ? value.value : null;
}

export const getNonEmptyString = (raw: unknown): string | null =>
  typeof raw === 'string' && raw ? raw : null;

export const getAttributeOptionByKey = (
  options: CustomAttributeOption[],
  key: string,
): CustomAttributeOption | undefined => options.find((option) => option.key === key);

export const getAttributeOptionLabel = (options: CustomAttributeOption[], key: string) =>
  getAttributeOptionByKey(options, key)?.value ?? key;
